import React, {useEffect, useState} from "react";
import {LeadModal} from "../dialogs/leadModal";
import LeadForm from "../dialogs/LeadForm";
import {
    Grid
} from "@mui/material";
import {$crud} from "../services/CrudFactory";
import {useSelector, useDispatch} from "react-redux";
import {usePagination} from "../hooks/usePagination";
import {useDataParams} from "../hooks";
import DynamicTable from "../components/DynamicTable";
import {columns} from "../helpers/tableData";
import {FilterChipContainer} from "../components";
import {ConfirmationModal} from "../dialogs/ConfirmationModal";
import Typography from "@mui/material/Typography";

export function Unsaved() {
    const [showLeadModal, setShowLeadModal] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [itemToRemove, setItemToRemove] = useState(null);
    const [showLeadForm, setShowLeadForm] = useState(false);
    const [reRun, setReRun] = useState(false);
    const [filtersWithValues, setFiltersWithValues] = useState({});
    const [leadId, setLeadId] = useState(null);
    const [leads, setLeads] = useState([]);

    // console.log(itemToRemove, "---------itemToRemove");

    const {
        limit,
        page,
        setTotal,
        total,
        setLimit,
        setPage
    } = usePagination();
    const dispatch = useDispatch();
    const {setParams} = useDataParams();

    const renderState = useSelector((state) => state.renderLead).render1;
    // const currentUser = useSelector((state) => state.userReducer);
    const filters = useSelector(state => state.filterReducer);

    const retrieveVisitedStudentLeads = async () => {
        try {
            dispatch({
                type: "LOADER",
                loader: true,
            });
            const {
                data: {leads, total},
            } = await $crud.retrieve("web/fresh-leads", {
                ...filtersWithValues,
                unSaved: true,
                page,
                limit,
            });
            return {leads, total};
        } catch (e) {
            dispatch({
                type: "SNACKBAR",
                snackBar: {type: "error", message: e.message},
            });
        } finally {
            dispatch({
                type: "LOADER",
                loader: false,
            });
        }
    };
    const removeLead = async (id) => {
        try {
            dispatch({
                type: "LOADER",
                loader: true,
            });
            const {
                type, message
            } = await $crud.post("delete/web/lead", {id});
            dispatch({
                type: "SNACKBAR",
                snackBar: {type, message},
            });
        } catch (e) {
            dispatch({
                type: "SNACKBAR",
                snackBar: {type: "error", message: e.message},
            });
        } finally {
            dispatch({
                type: "LOADER",
                loader: false,
            });
            setReRun(true);
            setShowConfirmationModal(false);
            setItemToRemove(null);
        }
    };

    useEffect(() => {
        setReRun(false);
        retrieveVisitedStudentLeads().then(res => {
            setLeads(res?.leads);
            setTotal(res?.total);
        }).catch(error => console.error(error));
    }, [limit, page, filtersWithValues, reRun, renderState]);

    useEffect(() => {
        setFiltersWithValues(filters?.withValues);
    }, [filters]);

    return (
        <>
            <Grid className="container-fluid top-navbar ">
                <FilterChipContainer/>
                <DynamicTable
                    rows={leads}
                    style={{
                        maxHeight: "calc(100vh - 250px)",
                        position: "fixed",
                        top: "150px",
                        width: "calc(100% - 24px)"
                    }}
                    columns={columns?.studentLead}
                    total={total}
                    onEdit={(id) => {
                        setShowLeadForm(true);
                        setLeadId(id);
                    }}
                    onRowClick={(id) => {
                        setShowLeadModal(true);
                        setLeadId(id);
                    }}
                    onDelete={(id) => {
                        setShowConfirmationModal(true);
                        setItemToRemove(id);
                    }}
                    
                    paginationProps={{
                        limit: limit,
                        page: page,
                        onChangeLimit: (limit) => setLimit(limit),
                        onChangePage: (page) => setPage(page),
                    }}
                />
            </Grid>

            <LeadModal
                anchor="right"
                open={showLeadModal}
                onClose={() => {
                    setShowLeadModal(false);
                    setLeadId(null);
                    setParams({});
                }}
                leadId={leadId}

            />

            <LeadForm
                leadId={leadId}
                anchor="right"
                open={showLeadForm}
                onClose={() => {
                    setShowLeadForm(false);
                    setLeadId(null);
                    setParams({});
                }}
                onOpen={(leadId) => {
                    setShowLeadModal(true);
                    setLeadId(leadId);
                }}
                onNew={() => {
                    setParams({});

                }}
            />

            <ConfirmationModal
                open={showConfirmationModal}
                onClose={() => setShowConfirmationModal(false)}
                onOk={() => removeLead(itemToRemove)}
                title={`Delete Lead #ID ${itemToRemove}`}
                content={<Typography variant={"body1"} component="span">Press Yes To Delete Lead From Database</Typography>}
            />

        </>
    );
}


